import React, { useState, useRef, useEffect } from "react";
import { Dimmer } from "../components/spinner";
import axios from "axios";
import GraficosAsignacion from "../components/timbres/graficosAsignacionTimbres";
import CatalogoAgenteTipo from "../catalogos/catalogoAgenteTipo";
import { formatMoneda, validaSoloNumero } from "../util/varios";
import Icono from "../../public/imagenes/escudo.png";
import { Mensaje } from "../components/mensajes";
import { useParams } from "react-router-dom";
import CatalogoAgenteTipo2 from "../catalogos/catalogoAgenteTipo2";

function AsignaTimbres(props) {
  /////#####Declaracion de variables#####/////

  /////variables nativas js
  var parametros = useParams();
  var tipo = parametros.tipo;
  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  var tipoplanilla =
    tipo === "TF" ? "Timbres Fiscales" : "Guia De Movilización";
  var titulo = tipo === "TF" ? "Expendedor" : "Mina";
  var clave = tipo === "TF" ? "expendedor" : "mina";
  var valor = true;
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const usuario = JSON.parse(localStorage.getItem("idusuario"));
  const idagente = JSON.parse(localStorage.getItem("idagente"));

  /////variables de referencias
  const txtIdPlanilla = useRef();
  const txtIdExpendedor = useRef();
  const txtdesde = useRef();
  const txthasta = useRef();

  /////variables de estados
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [activate2, setActivate2] = useState(false);
  const [codigoPlanilla, setCodigoPlanilla] = useState("0");
  const [valorPlanilla, setValorPlanilla] = useState(0.0);
  const [expendedor, setExpendedor] = useState();
  const [planilla, setPlanilla] = useState([]);
  const [disponibles, setDisponibles] = useState(0);
  const [habilitado, setHabilitado] = useState();
  const [inhabilitado, setInhabilitado] = useState(true);
  const [seleccionado, setSeleccionado] = useState([]);
  const [cantidad, setCantidad] = useState(0);
  const [todos, setTodos] = useState("0");
  const [desdehasta, setDesdeHasta] = useState({ desde: 0, hasta: 0 });
  const [mostrarcatalogo, setMostrarcatalogo] = useState(false);
  const [idtimbres, setIdtimbres] = useState([]);
  const [total, setTotal] = useState(0);
  const [cantmax, setCantMax] = useState(0);
  const [records, setRecords] = useState([]);
  const [asignados, setAsignados] = useState([]);
  const [enterados, setEnterados] = useState([]);
  const [vendidos, setVendidos] = useState([]);
  const [valores, setValores] = useState([]);
  const [valido, setValido] = useState({ num1: 0, num2: 0 });

  const [habilitadoNU, setHabilitadoNU] = useState({
    codigo: false,
    codigoplanilla: false,
    alicuota: false,
    descripcion: false,
    minimo: false,
  });

  const onFocus = (e) => {
    setHabilitadoNU({ ...habilitadoNU, [e.target.name]: true });
  };

  const onColor = (v) => {
    var c = "#17a2b8";
    switch (v) {
      case 1:
        c = "#bfbdbd";
        break;
      case 2:
        c = "#28a745";
        break;
      case 3:
        c = "#ff9900";
        break;
      case 4:
        c = "#5a2a00fa";
        break;
      case 5:
        c = "#dc3545";
        break;
      default:
        c = "#17a2b8";
        break;
    }

    return c;
  };

  const onEstatus = (v) => {
    var c = "DISPONIBLE";
    switch (v) {
      case 1:
        c = "ASIGNADO";
        break;
      case 2:
        c = "VENDIDO";
        break;
      case 3:
        c = "INHABILITADO";
        break;
      case 4:
        c = "ANULADO";
        break;
      case 5:
        c = "ASIGNADO";
        break;
      default:
        c = "DISPONIBLE";
        break;
    }

    return c;
  };
  /////#####$$$$$#####/////

  /////#####Consultar Expendedor por el id#####/////
  const gestionarExpendedor = (id) => {
    setActivate2(true);

    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";
    let orden = "idagente";
    let status = "";
    let endpoint1 = `${op.conexion}/api/consulta/idsstring2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=expendedor&id2=true&orden=${orden}`;
    let endpoint2 = `${op.conexion}/api/consulta/idsstring2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=mina&id2=true&orden=${orden}`;
    let endpoint3 = tipo === "TF" ? endpoint1 : endpoint2;

    axios
      .get(endpoint3, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idagente > 0) {
            status =
              tipo === "TF"
                ? response.data.statusexpe
                : response.data.statusmina;

            if (status === "52") {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El Expendedor no se encuentra Activo.",
                icono: "informacion",
              });
            } else {
              setExpendedor(response.data);
              gestionartimbredetalle(response.data.idagente);
              setInhabilitado(false);
              setPlanilla([]);
              setHabilitado();
              setDisponibles(0);
              txtIdPlanilla.current.value = "";
              txtIdPlanilla.current.focus();
              blanquearPlanilla();
            }
          } else {
            blanquearExpendedor();
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "no existe un expendedor con ese codigo",
              icono: "informacion",
            });
          }
          setActivate2(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate2(false);
      });
  };
  /////#####$$$$$#####/////

  /////#####Consultar Planilla por el id#####/////
  const gestionarPlanilla = (id) => {
    setActivate(true);

    let endpoint = op.conexion + "/api/timbres/planilla/" + id;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let disp = 0;
          let nodisp = 0;
          let habili = [];
          let ini = 0;
          let fin = 0;

          if (response.data.length > 0) {
            console.log(response.data[0].codigotimbre.includes(tipo));
            if (response.data[0].codigotimbre.includes(tipo)) {
              setPlanilla(response.data);
              setValorPlanilla(response.data[0].ut);
              setCodigoPlanilla(response.data[0].idplanillatimbre);
              for (let i = 0; i < response.data.length; i++) {
                if (response.data[i].estatustimbre === 0 && ini === 0) {
                  ini = parseInt(response.data[i].idtimbredetalle);
                } else if (response.data[i].estatustimbre === 0) {
                  fin = parseInt(response.data[i].idtimbredetalle);
                }

                if (response.data[i].estatustimbre === 0) {
                  disp += 1;
                  habili.push({
                    id: response.data[i].idtimbredetalle,
                    status: response.data[i].estatustimbre,
                  });
                } else {
                  nodisp += 1;
                  // habili.push({id: response.data[i].idtimbredetalle, status: response.data[i].estatustimbre})
                }
              }

              setCantMax(fin);
              setValido({ num1: 0, num2: ini });
              setDesdeHasta({ desde: ini, hasta: fin });
              setDisponibles(disp);
              setSeleccionado(response.data);
            } else {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El tipo de planilla es : " + tipo,
                icono: "informacion",
              });
            }
          } else {
            setPlanilla([]);
            setDisponibles(0);
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "no existe una planilla con ese codigo",
              icono: "informacion",
            });
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };
  /////#####$$$$$#####/////

  /////#####funcion para buscar la planilla por el id#####/////
  const buscarPlanilla = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        let seguir = true;

        if (records.length > 0) {
          for (let i = 0; i < records.length; i++) {
            if (parseInt(event.target.value) === parseInt(records[i].codigo)) {
              seguir = false;
            }
          }
        }

        if (seguir) {
          gestionarPlanilla(event.target.value);
          blanquearPlanilla();
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "esta planilla ya fue seleccionada.",
            icono: "informacion",
          });
        }
      }
    }
  };
  /////#####$$$$$#####/////

  /////#####funcion para buscar el expendedor por el id#####/////
  const buscarExpendedor = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        gestionarExpendedor(event.target.value);
      }
    }
  };
  /////#####$$$$$#####/////

  /////#####funcion para capturar solo numeros#####/////
  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      event.target.value = event.target.value;
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
    setDesdeHasta({ ...desdehasta, [event.target.name]: event.target.value });
  };
  /////#####$$$$$#####/////

  /////#####funcion para seleccionar todos los timbres de la planilla#####/////
  const seleccionarTodos = () => {
    let select = 0;
    let dispo = 0;
    var datos = [...seleccionado];
    var n1 = 0;

    if (datos.length > 0) {
      for (let i = 0; i < datos.length; i++) {
        if (
          seleccionado[i].estatustimbre === 0 ||
          seleccionado[i].estatustimbre === 5
        ) {
          n1 = parseInt(seleccionado[i].idtimbredetalle);

          datos[i].estatustimbre = 5;
          select = select + 1;
          dispo = 0;
          setIdtimbres([
            ...idtimbres,
            {
              idtimbredetalle: seleccionado[i].idtimbredetalle,
              usuarioasignado: idagente,
              idexpendio: txtIdExpendedor.current.value,
              fechaasignado: fechaSistema,
              estatustimbre: 1,
              valorut_asignacion: seleccionado[i].ut,
            },
          ]);
        } else if (seleccionado[i].estatustimbre === 5) {
          if (n1 === 0) {
            n1 = parseInt(seleccionado[i].idtimbredetalle);
          }
          select = 0;
          dispo += 1;
          datos[i].estatustimbre = 0;
          setIdtimbres(
            idtimbres.filter(
              (it) => it.idtimbredetalle !== datos[i].idtimbredetalle
            )
          );
        }
      }

      setValido({ num1: 0, num2: n1 });
      setDisponibles(dispo);
      setSeleccionado(datos);
      setCantidad(select);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "No a Seleccionado una planilla.",
        icono: "informacion",
      });
      txtIdPlanilla.current.focus();
    }
  };

  const deseleccionarTodos = () => {
    let select = 0;
    let dispo = 0;
    var datos = [...seleccionado];
    var n1 = 0;

    if (datos.length > 0) {
      for (let i = 0; i < seleccionado.length; i++) {
        if (
          seleccionado[i].estatustimbre === 5 ||
          seleccionado[i].estatustimbre === 0
        ) {
          if (n1 === 0) {
            n1 = parseInt(seleccionado[i].idtimbredetalle);
          }
          select = 0;
          dispo += 1;
          datos[i].estatustimbre = 0;
          setIdtimbres(
            idtimbres.filter(
              (it) => it.idtimbredetalle !== datos[i].idtimbredetalle
            )
          );
        }
      }

      setValido({ num1: 0, num2: n1 });
      setDisponibles(dispo);
      setSeleccionado(datos);
      setCantidad(select);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "No a Seleccionado una planilla.",
        icono: "informacion",
      });
      txtIdPlanilla.current.focus();
    }
  };
  /////#####$$$$$#####/////

  /////#####funcion para seleccionar los timbres de la planilla por limite desde hasta#####/////
  const seleccionarxDesde = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (parseInt(txthasta.current.value) > cantmax) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: `El numero no debe ser mayor a ${cantmax}`,
            icono: "informacion",
          });
        } else if (parseInt(txthasta.current.value) <= desdehasta.desde) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "El numero no debe ser menor o igual a " + desdehasta.desde,
            icono: "informacion",
          });
        } else {
          const element = [];
          let select = 0;
          const tim = [];
          let dispo = 0;
          let j = desdehasta.desde;

          for (let index = 0; index < planilla.length; index++) {
            if (planilla[index].estatustimbre === 0) {
              dispo += 1;
            }
          }

          for (let i = 0; i < planilla.length; i++) {
            if (desdehasta.hasta > j && planilla[i].estatustimbre === 0) {
              j = parseInt(planilla[i].idtimbredetalle);

              console.log(j);
              element.push({
                idtimbredetalle: planilla[i].idtimbredetalle,
                estatustimbre: 5,
              });
              tim.push({
                idtimbredetalle: planilla[i].idtimbredetalle,
                usuarioasignado: idagente,
                idexpendio: txtIdExpendedor.current.value,
                fechaasignado: fechaSistema,
                estatustimbre: 1,
                valorut_asignacion: planilla[i].ut,
              });
              select += 1;
              dispo -= 1;
            } else {
              element.push({
                idtimbredetalle: planilla[i].idtimbredetalle,
                estatustimbre: planilla[i].estatustimbre,
              });
            }
          }
          setSeleccionado(element);
          setDisponibles(dispo);
          setCantidad(select);
          setIdtimbres(tim);
        }
      }
    }
  };
  /////#####$$$$$#####/////

  /////#####funcion para capturar el evento del click en el timbre seleccionado#####/////
  const clickTimbre = (item, index, num1) => (e) => {
    e.preventDefault();
    var data = [...seleccionado];
    var n1 = 0;
    var n2 = 0;

    if (item.estatustimbre === 0) {
      data[index].estatustimbre = 5;

      setIdtimbres([
        ...idtimbres,
        {
          idtimbredetalle: item.idtimbredetalle,
          usuarioasignado: idagente,
          idexpendio: txtIdExpendedor.current.value,
          fechaasignado: fechaSistema,
          estatustimbre: 1,
          valorut_asignacion: item.ut,
        },
      ]);

      for (let i = 0; i < seleccionado.length; i++) {
        if (data[i].estatustimbre === 0 && n1 === 0) {
          n1 = parseInt(data[i].idtimbredetalle);
        }
      }

      setDisponibles(disponibles - 1);
      setCantidad(cantidad + 1);
      setValido({ ...valido, num1: num1, num2: n1 });
    } else {
      for (let i = 0; i < seleccionado.length; i++) {
        if (data[i].estatustimbre === 5 && data[i].idtimbredetalle !== num1) {
          n2 = parseInt(data[i].idtimbredetalle);
        }
      }

      data[index].estatustimbre = 0;

      for (let i = 0; i < seleccionado.length; i++) {
        if (data[i].estatustimbre === 5 && data[i].idtimbredetalle !== n2) {
          n1 = parseInt(data[i].idtimbredetalle);
        }
      }

      setIdtimbres(
        idtimbres.filter((it) => it.idtimbredetalle !== item.idtimbredetalle)
      );
      setDisponibles(disponibles + 1);
      setCantidad(cantidad - 1);
      setValido({ ...valido, num1: n1, num2: n2 });
    }

    setHabilitado({ ...habilitado, [index]: item });
    setSeleccionado(data);
  };
  /////#####$$$$$#####/////

  /////#####funcion para blaquear los campos del expendedor#####/////
  const blanquearExpendedor = () => {
    setExpendedor();
    setHabilitado();
    blanquearPlanilla();
    setInhabilitado(true);
    setAsignados([]);
    setEnterados([]);
    setVendidos([]);
    setValores([]);
    setRecords([]);
    setTotal(0);
    txtIdExpendedor.current.value = "";
    txtIdPlanilla.current.value = "";
  };
  /////#####$$$$$#####/////

  /////#####funcion para seleccionar el expendedor desde el catalogo#####/////
  const seleccionarExpendedor = (idage, nombage, status, direcc, nre, nli) => {
    if (status === "52") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Expendedor no se encuentra Activo.",
        icono: "informacion",
      });
      txtIdExpendedor.current.value = "";
      txtIdPlanilla.current.value = "";
      blanquearPlanilla();
      blanquearExpendedor();
      setInhabilitado(true);
      setPlanilla([]);
      setDisponibles(0);
    } else {
      setExpendedor({
        idagente: idage,
        status: status,
        nombre: nombage,
        direccion: direcc,
        nroresolucion: nre,
        nrolicencia: nli,
      });
      gestionartimbredetalle(idage);
      setInhabilitado(false);
      setPlanilla([]);
      setHabilitado();
      setDisponibles(0);
      txtIdExpendedor.current.value = idage;
      txtIdPlanilla.current.value = "";
      blanquearPlanilla();
    }
  };
  /////#####$$$$$#####/////

  /////#####funcion para abrir el catalogo de expendedores#####/////
  const catalogoExpendedor = () => {
    setMostrarcatalogo(true);
  };
  /////#####$$$$$#####/////

  /////#####funcion para cerrar el catalogo de expendedores#####/////
  const cerrarCatalogo = () => {
    setMostrarcatalogo(false);
  };
  /////#####$$$$$#####/////

  /////#####funcion para blamquear los campos de la planilla#####/////
  const blanquearPlanilla = () => {
    setPlanilla([]);
    setSeleccionado([]);
    setValido({ num1: 0, num2: 0 });
    setCantidad(0);
    setCantMax(0);
    setCodigoPlanilla(0);
    setValorPlanilla("");
    setDisponibles(0);
    setTodos("0");
    setDesdeHasta({ desde: "0", hasta: "0" });
    setIdtimbres([]);
  };
  /////#####$$$$$#####/////

  /////#####funcion para agregar los timbres a la tabla#####/////
  const agregarSeleccionados = () => {
    var element = cantidad;

    if (txtIdPlanilla.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Campo Codigo no Debe estar Vacio.",
        icono: "informacion",
      });
      txtIdPlanilla.current.focus();
    } else {
      if (cantidad > 0) {
        setRecords((arr) => [
          ...arr,
          {
            disponibles: disponibles,
            seleccionado: seleccionado,
            codigo: codigoPlanilla,
            cantidad: cantidad,
            valor: valorPlanilla,
            idtimbres: idtimbres,
            valido: valido,
            cantmax: cantmax,
            planilla: planilla,
            desde: desdehasta,
          },
        ]);
        blanquearPlanilla();
        txtIdPlanilla.current.value = "";
        if (records.length > 0) {
          for (let i = 0; i < records.length; i++) {
            element = element + records[i].cantidad;
          }
        }
        setTotal(element);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "No hay Timbres Seleccionados.",
          icono: "informacion",
        });
      }
    }
  };
  /////#####$$$$$#####/////

  /////#####edita un timbre de la tabla#####/////
  const editarPlanilla = (item) => {
    txtIdPlanilla.current.value = item.codigo;
    setPlanilla(item.planilla);
    setValido(item.valido);
    setCodigoPlanilla(item.codigo);
    setValorPlanilla(item.valor);
    setCantMax(item.cantmax);
    setDisponibles(item.disponibles);
    setSeleccionado(item.seleccionado);
    setCantidad(item.cantidad);
    setIdtimbres(item.idtimbres);
    setDesdeHasta(item.desde);

    eliminarPlanilla(item);
  };
  /////#####$$$$$#####/////

  /////#####elimina un timbre de la tabla#####/////
  const eliminarPlanilla = (item) => {
    let element = [];
    let to = total - item.cantidad;
    for (let i = 0; i < records.length; i++) {
      if (records[i].codigo !== item.codigo) {
        element.push(records[i]);
      }
    }
    setRecords(element);
    setTotal(to);
  };
  /////#####$$$$$#####/////

  /////#####proceso de actualizacion#####/////
  const procesarRegistro = (body) => {
    setActivate(true);
    let endpoint = "";
    endpoint = `${op.conexion}/api/timbres/actualizartimbres`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.respuesta > 0) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: `${response.data.respuesta} Timbres Asignados Correctamente.`,
              icono: "exito",
            });
          }
          setActivate(false);
          setRecords([]);
          setTotal(0);
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  /////#####$$$$$#####/////

  /////#####funcion para agregar los timbres al body#####/////
  const asignarTimbres = () => {
    const element = [];
    for (let i = 0; i < records.length; i++) {
      for (let j = 0; j < records[i].idtimbres.length; j++) {
        element.push(records[i].idtimbres[j]);
      }
    }
    let body = {
      timbres: element,
    };
    if (element.length > 0) {
      procesarRegistro(body);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "No hay Timbres Seleccionados Para ser Asignados.",
        icono: "informacion",
      });
    }
  };
  /////#####$$$$$#####/////

  /////#####Consulta para los Graficos#####/////
  const gestionartimbredetalle = (id) => {
    setActivate(true);
    let body = {
      bloque1: "*",
      bloque2: "timbredetalle",
      bloque3: `idexpendio= ${id} order by idtimbredetalle asc`,
    };
    let endpoint = op.conexion + "/api/timbres/detalletimbre";

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          const asignado = [];
          const enterado = [];
          const vendido = [];
          const valore = [];
          let conteo = 0;
          let conteo2 = 0;
          let conteo3 = 0;
          let valor = 0.0;
          let indice = 0;
          let indice2 = 0;
          let indice3 = 0;

          for (let j = 0; j < response.data.length; j++) {
            if (response.data[j].ut !== valor) {
              valor = response.data[j].ut;
              valore.push(response.data[j].ut.toString());
            }
          }

          if (response.data.length > 0) {
            for (let j = 0; j < valore.length; j++) {
              for (let i = 0; i < response.data.length; i++) {
                //asignado
                if (valore[j] === response.data[i].ut.toString()) {
                  conteo += 1;
                  if (indice !== j) {
                    indice = j;
                    conteo = 1;
                  }
                }
              }
              asignado.push(conteo.toString());
            }

            for (let j = 0; j < valore.length; j++) {
              conteo2 = 0;
              for (let i = 0; i < response.data.length; i++) {
                //enterados
                if (
                  valore[j] === response.data[i].ut.toString() &&
                  response.data[i].enterado === true
                ) {
                  conteo2 += 1;
                  if (indice2 !== j) {
                    indice2 = j;
                    conteo2 = 1;
                  }
                }
              }
              enterado.push(conteo2.toString());
            }
            for (let j = 0; j < valore.length; j++) {
              conteo3 = 0;
              for (let i = 0; i < response.data.length; i++) {
                //vendidos
                if (
                  valore[j] === response.data[i].ut.toString() &&
                  response.data[i].fechahabilitado !== null
                ) {
                  conteo3 += 1;
                  if (indice3 !== j) {
                    indice3 = j;
                    conteo3 = 1;
                  }
                }
              }
              vendido.push(conteo3.toString());
            }
            setAsignados(asignado);
            setEnterados(enterado);
            setVendidos(vendido);
            setValores(valore);
          } else {
            setAsignados([]);
            setEnterados([]);
            setVendidos([]);
            setValores([]);
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };
  /////#####$$$$$#####/////

  useEffect(() => {
    if (txtIdExpendedor.current.value === "") {
      txtIdExpendedor.current.focus();
    }
  }, []);

  return (
    <div className="container-fluid px-3 py-3">
      <ul className="nav mb-3 h-25" id="ex-with-icons" role="tablist">
        <li className="nav-item" role="presentation">
          <a
            className="nav-link text-dark rounded"
            style={{ backgroundColor: "#25d366" }}
            id="ex-with-icons-tab-1"
            data-mdb-toggle="tab"
            href="#ex-with-icons-tabs-1"
            role="tab"
            aria-controls="ex-with-icons-tabs-1"
            aria-selected="true"
          >
            <i className="fas fa-chart-pie fa-fw me-2" />
            Asignación de {tipoplanilla}
          </a>
        </li>
        <li className="nav-item" role="presentation">
          <a
            className="nav-link text-dark rounded"
            style={{ backgroundColor: "#55acee" }}
            id="ex-with-icons-tab-2"
            data-mdb-toggle="tab"
            href="#ex-with-icons-tabs-2"
            role="tab"
            aria-controls="ex-with-icons-tabs-2"
            aria-selected="false"
          >
            <i className="fas fa-chart-line fa-fw me-2" />
            Graficos de {tipoplanilla}
          </a>
        </li>
      </ul>
      <div className="tab-content" id="ex-with-icons-content">
        <div
          className="tab-pane fade show active"
          id="ex-with-icons-tabs-1"
          role="tabpanel"
          aria-labelledby="ex-with-icons-tab-1"
        >
          <section className="row">
            <div className="col-md-5 w-100">
              <div className="col-md-12">
                <div className="card-body px-0 py-0">
                  <div className="row">
                    <div
                      className="col-md-6"
                      style={{
                        backgroundColor: "white",
                        boxShadow: "0px 0px 10px 1px #aaaaaa",
                      }}
                    >
                      <p className="h5 text-center">
                        <strong>
                          {tipo === "TF"
                            ? "Datos del Expendedor"
                            : "Datos de la Mina"}
                        </strong>
                      </p>
                      <div className="mx-4 my-4 was-validated">
                        <Dimmer active={activate2} />
                        <div className="input-group input-group-sm mb-3">
                          <label
                            htmlFor="codigo"
                            className="form-label input-group-text"
                            id="validationTooltipCodigo"
                            style={{ backgroundColor: "#55acee" }}
                          >
                            Código:
                          </label>
                          {/* <span className="input-group-text fw-bold text-dark" style={{ backgroundColor: "#55acee" }} id="inputGroup-sizing-sm">Codigo</span> */}
                          <input
                            type="text"
                            autoComplete="off"
                            onKeyUp={buscarExpendedor}
                            ref={txtIdExpendedor}
                            name="codigo"
                            aria-describedby="validationTooltipCodigo"
                            onFocus={onFocus}
                            placeholder="Código"
                            className="form-control border"
                            required
                          />
                          {habilitadoNU.codigo === true ? (
                            <div
                              className="invalid-feedback bg-dark shadow-5-strong"
                              id="pruetoltasig"
                            >
                              <p className="ml-2">
                                Introduzca el Código {titulo}. &nbsp;
                              </p>
                            </div>
                          ) : (
                            ""
                          )}
                          <button
                            className="btn btn-info"
                            onClick={catalogoExpendedor}
                          >
                            <i className="fa fa-search"></i>
                          </button>
                        </div>
                        <p className="text-muted">
                          <i className="fas fa-user-alt me-2" />
                          {titulo}: {expendedor && expendedor.nombre}
                        </p>
                        <hr className="dropdown-divider" />
                        <div className="row">
                          <div className="col-md-12">
                            <ol className="list-unstyled mb-0 pt-0 pb-0">
                              <li className="mb-1">
                                <i className="fas fa-home me-2" />
                                <small>
                                  Dirección:{" "}
                                  {expendedor && expendedor.direccion}{" "}
                                </small>
                              </li>
                              <li className="mb-1">
                                <i className="fas fa-chalkboard-teacher me-2" />
                                <small>
                                  N°-Resolución:{" "}
                                  {expendedor && expendedor.nroresolucion}{" "}
                                </small>
                              </li>
                              <li className="mb-1">
                                <i className="fas fa-id-badge me-2" />
                                <small>
                                  N°-Licencia:{" "}
                                  {expendedor && expendedor.nrolicencia}
                                </small>
                              </li>
                            </ol>
                          </div>
                        </div>
                        <div className="card-footer row">
                          <div className="col-md-4 mr-auto">
                            <button
                              type="button"
                              onClick={blanquearExpendedor}
                              disabled={inhabilitado}
                              className="btn btn-danger btn-sm"
                            >
                              Cancelar
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-md-6 text-center"
                      style={{
                        backgroundColor: "#F9FAFB",
                        boxShadow: "0px 0px 10px 1px #aaaaaa",
                      }}
                    >
                      {inhabilitado ? (
                        <div
                          className="bg-image h-100 w-100 mask"
                          style={{ backgroundColor: "rgba(0, 0, 0, 0.1)" }}
                        ></div>
                      ) : (
                        ""
                      )}

                      <p className="h5">
                        <strong>Datos de la Planilla</strong>
                      </p>
                      <div className="mx-4 my-4 was-validated">
                        <div className="input-group input-group-sm mb-3">
                          <label
                            htmlFor="codigoplanilla"
                            className="form-label input-group-text"
                            id="validationTooltipPlanilla"
                            style={{ backgroundColor: "#55acee" }}
                          >
                            N° de Planilla:
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            onKeyUp={buscarPlanilla}
                            ref={txtIdPlanilla}
                            onFocus={onFocus}
                            disabled={inhabilitado}
                            aria-describedby="validationTooltipPlanilla"
                            placeholder="Código"
                            name="codigoplanilla"
                            className="form-control border"
                            required
                          />
                          {habilitadoNU.codigoplanilla === true ? (
                            <div
                              className="invalid-feedback bg-dark shadow-5-strong"
                              id="pruetoltasig"
                            >
                              <p className="ml-2">
                                Introduzca el Código de la Planilla. &nbsp;
                              </p>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <p
                        className="text-uppercase text-primary mb-0 new-section"
                        style={{ fontSize: 14 }}
                      >
                        <span className="line-pricing" />
                        Código N°-{" "}
                        {planilla.length > 0 ? planilla[0].idplanillatimbre : 0}
                      </p>
                      <hr className="dropdown-divider" />
                      <div className=" mt-1 pt-1 me-1">
                        <p className="h6">Valor del Timbre</p>
                        <p
                          className="h2 fw-bold text-black"
                          style={{ fontSize: 15 }}
                        >
                          {planilla.length > 0
                            ? formatMoneda(
                                planilla[0].ut.toString().replace(".", ","),
                                ",",
                                ".",
                                2
                              )
                            : "0,00"}{" "}
                          <small
                            className="text-muted"
                            style={{ fontSize: 15 }}
                          >
                            UTE
                          </small>
                        </p>
                        <p
                          className="text-decoration-underline text-black-50 "
                          style={{ fontSize: 15 }}
                        ></p>
                        <div className="">
                          <div
                            className="col-md-12"
                            style={{ textAlign: "left" }}
                          >
                            <p className="fw-bold" style={{ fontSize: 10 }}>
                              Total Timbres:{" "}
                              <span style={{ color: "#007bff" }}>
                                {planilla.length > 0 ? planilla.length : 0}
                              </span>
                            </p>
                            <p className="fw-bold" style={{ fontSize: 10 }}>
                              Disponibles:{" "}
                              <span style={{ color: "#17a2b8" }}>
                                {disponibles}
                              </span>
                            </p>
                            <p className="fw-bold" style={{ fontSize: 10 }}>
                              Seleccionados:{" "}
                              <span style={{ color: "#dc3545" }}>
                                {cantidad}
                              </span>
                            </p>
                          </div>
                          <div
                            className="card-footer col-md-12 row"
                            style={{ margin: 0 }}
                          >
                            <div className="col-md-6 col-6">
                              <button
                                type="button"
                                onClick={blanquearPlanilla}
                                disabled={inhabilitado}
                                className="btn btn-warning btn-sm"
                              >
                                Cancelar
                              </button>
                            </div>
                            <div className="col-md-6 col-6">
                              <button
                                type="button"
                                onClick={agregarSeleccionados}
                                disabled={inhabilitado}
                                className="btn btn-primary btn-sm"
                              >
                                Agregar
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="card-body px-0 py-0 col-12"
                      style={{ backgroundColor: "white" }}
                    >
                      {inhabilitado ? (
                        <div
                          className="bg-image h-100 w-100 mask"
                          style={{ backgroundColor: "rgba(0, 0, 0, 0.1)" }}
                        ></div>
                      ) : (
                        ""
                      )}
                      <div className="row" style={{ margin: 0, padding: 0 }}>
                        <div className="card-body col-md-9 col-sm-9 col-xl-9 col-9 d-flex justify-content-evenly">
                          <table className="table tablet-responsive table-bordered table-striped">
                            <thead>
                              <tr>
                                <th>planilla</th>
                                <th>valor</th>
                                <th>cantidad</th>
                                <th>opciónes</th>
                              </tr>
                            </thead>
                            <tbody>
                              {records &&
                                records.map((item, index) => (
                                  <tr key={index} style={{ padding: "0" }}>
                                    <td
                                      style={{
                                        fontSize: "10px",
                                        textAlign: "center",
                                        border: "rgb(14, 101, 238) 1px solid",
                                        padding: 0,
                                        margin: 0,
                                      }}
                                    >
                                      {item.codigo}
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "10px",
                                        textAlign: "center",
                                        border: "rgb(14, 101, 238) 1px solid",
                                        padding: 0,
                                        margin: 0,
                                      }}
                                    >
                                      {formatMoneda(
                                        item.valor.toString().replace(".", ","),
                                        ",",
                                        ".",
                                        2
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "10px",
                                        textAlign: "center",
                                        border: "rgb(14, 101, 238) 1px solid",
                                        padding: 0,
                                        margin: 0,
                                      }}
                                    >
                                      {item.cantidad}
                                    </td>
                                    <td
                                      style={{
                                        textAlign: "center",
                                        border: "rgb(14, 101, 238) 1px solid",
                                        padding: 0,
                                        margin: 0,
                                      }}
                                      className="row"
                                    >
                                      <button
                                        onClick={() => editarPlanilla(item)}
                                        style={{
                                          padding: 0,
                                          margin: 0,
                                          color: "#ffffff",
                                          backgroundColor: "#0054bd",
                                        }}
                                        className="btn col-6 btn-sm"
                                      >
                                        <i className="fa fa-edit"></i>{" "}
                                      </button>
                                      <button
                                        onClick={() => eliminarPlanilla(item)}
                                        style={{
                                          padding: 0,
                                          margin: 0,
                                          color: "#ffffff",
                                          backgroundColor: "#ff0000",
                                        }}
                                        className="btn col-6 btn-sm"
                                      >
                                        <i className="fa fa-trash"></i>{" "}
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                        <div className="col-md-3 col-xl-3 col-3 col-sm-3">
                          <div className="py-4 ml-0 m-0">
                            <button
                              type="button"
                              onClick={asignarTimbres}
                              disabled={inhabilitado}
                              className="btn btn-success btn-sm"
                            >
                              Asignar
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="card-footer">
                        <div className="row">
                          <div className="col-md-4 ml-auto d-flex justify-content-evenly">
                            <div className="form-outline">
                              <label className="form-label" htmlFor="form12">
                                Total: {total}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-7 w-100">
              <div className="container col-md-12" style={{ height: "400px" }}>
                <div className="container col-md-12 row">
                  <div className="col-md-6 py-2">
                    <button
                      onClick={seleccionarTodos}
                      disabled={inhabilitado}
                      className="btn btn-sm btn-danger mx-2"
                    >
                      Marcar
                    </button>
                    <button
                      onClick={deseleccionarTodos}
                      disabled={inhabilitado}
                      className="btn btn-sm btn-info mx-2"
                    >
                      Desmarcar
                    </button>
                    {/* <div className="form-check form-check-inline fw-bold">
                                            <input className="form-check-input" disabled={inhabilitado} onChange={seleccionarTodos} type="checkbox" name='todos' id="inlineCheckbox1" checked={todos === '1' ? true : false} value='1' />
                                            <label className="form-check-label">Seleccionar Todos</label>
                                        </div> */}
                  </div>
                  <div className="col-md-2 col-4">
                    <div className="input-group input-group-sm mb-3">
                      <span
                        className="input-group-text text-dark fw-bold"
                        style={{ backgroundColor: "#55acee" }}
                        id="inputGroup-sizing-sm"
                      >
                        Desde
                      </span>
                      <input
                        type="text"
                        ref={txtdesde}
                        name="desde"
                        disabled
                        value={desdehasta.desde}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                  </div>
                  <div className="col-md-2 col-4">
                    <div className="input-group input-group-sm mb-3">
                      <span
                        className="input-group-text text-dark fw-bold"
                        style={{ backgroundColor: "#55acee" }}
                        id="inputGroup-sizing-sm"
                      >
                        Hasta
                      </span>
                      <input
                        type="text"
                        ref={txthasta}
                        name="hasta"
                        disabled={inhabilitado}
                        onChange={handleInputNumChange}
                        onKeyUp={seleccionarxDesde}
                        value={desdehasta.hasta}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                  </div>
                </div>
                <div className="bg-image h-100 w-100">
                  <Dimmer active={activate} />
                  <div
                    className="mask"
                    style={{ backgroundColor: "rgba(0, 0, 0, 0.1)" }}
                  >
                    <div
                      className="list-group list-group-horizontal row h-100 col-md-12"
                      style={{ margin: 0, padding: 0 }}
                    >
                      <ul
                        className="list-group list-group-horizontal row col-md-12"
                        style={{ height: "14.29%", margin: 0, padding: 0 }}
                      >
                        {seleccionado &&
                          seleccionado.map((item, index) => (
                            <button
                              key={index}
                              onClick={clickTimbre(item, index, valido.num2)}
                              className="btn card col-md-2 h-100 bg-gradient p-0 m-0"
                              style={{
                                backgroundColor: onColor(item.estatustimbre),
                                pointerEvents:
                                  (item.estatustimbre === 0 ||
                                    item.estatustimbre === 5) &&
                                  (valido.num1 ===
                                    parseInt(item.idtimbredetalle) ||
                                    valido.num2 ===
                                      parseInt(item.idtimbredetalle))
                                    ? "auto"
                                    : "none",
                              }}
                            >
                              <img
                                src={Icono}
                                className="d-flex justify-content-evenly"
                                alt="Sample"
                                style={{ height: "20px", width: "20px" }}
                              />
                              <p
                                className="bg-transparent d-flex justify-content-evenly mx-auto fw-bold"
                                style={{ fontSize: 10 }}
                              >
                                {onEstatus(item.estatustimbre)}
                              </p>
                              <p
                                className="bg-transparent d-flex justify-content-evenly mx-auto"
                                style={{ fontSize: 10 }}
                              >
                                C-{item.idtimbredetalle}
                              </p>
                            </button>
                          ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div
          className="tab-pane fade"
          id="ex-with-icons-tabs-2"
          role="tabpanel"
          aria-labelledby="ex-with-icons-tab-2"
        >
          <GraficosAsignacion
            tipo={tipo}
            expendedor={expendedor}
            valores={valores}
            asignados={asignados}
            enterados={enterados}
            vendidos={vendidos}
          />
        </div>
      </div>
      {/*  <CatalogoAgenteTipo show={mostrarcatalogo} tipo={4} onHideAceptaCatAge={seleccionarExpendedor} onHideCancelaCatAge={cerrarCatalogo} /> */}
      <CatalogoAgenteTipo2
        show={mostrarcatalogo}
        campoclave={clave}
        valorclave={valor}
        onHideAceptaCatAge={seleccionarExpendedor}
        onHideCancelaCatAge={cerrarCatalogo}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
    </div>
  );
}

export default AsignaTimbres;

/////////////#####$$$$$#####/////////////////
/////#####Asignacion de Timbres#####/////////
/////#####Programador: Cesar Ratia#####/////
/////#####Empresa: Sygre.ca#####///////////
///////////#####$$$$$#####////////////////



// WEBPACK FOOTER //
// ./src/pages/asgtimbresf.js